var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPersistenceXprtLogo = function SvgPersistenceXprtLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 37,
    viewBox: "0 0 38 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.88.983H3.12C1.94.983.982 1.94.982 3.118v31.736c0 1.18.956 2.135 2.136 2.135h31.762c1.18 0 2.136-.956 2.136-2.135V3.118A2.136 2.136 0 0 0 34.881.983Z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.506 20.097c0 1.444-.333 2.77-.996 3.976-.663 1.183-1.683 2.143-3.057 2.877-1.373.734-3.08 1.1-5.117 1.1h-3.767V37H9.492V12.072h9.844c1.99 0 3.672.343 5.046 1.03 1.374.685 2.404 1.633 3.091 2.84.687 1.206 1.03 2.592 1.03 4.155h.003Zm-9.63 3.125c1.16 0 2.026-.272 2.594-.816.568-.543.854-1.314.854-2.307 0-.993-.286-1.764-.854-2.308-.568-.543-1.434-.815-2.594-.815H15.57v6.248h3.305v-.002Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.506 5.758H9.494V9.77h19.012V5.758Z",
    fill: "#E50913"
  })));
};
export { SvgPersistenceXprtLogo as ReactComponent };